module.exports = __webpack_public_path__ + "static/home-feature-1-v3-e4b4ca91b4b85528fea0d2bda4857f5f.svg";